/**
 * NeurologyCard — v1.1 refactor.
 * Neurology table (Reflexes / Myotomes / Dermatomes / Neurodynamic) with
 * per-test reference link (Physiopedia). Lifted out of
 * ObjectiveAssessment.jsx.
 */
import React from 'react';
import { Crosshair, Trash2, ExternalLink } from 'lucide-react';

const SIDES = ['L','R','Both','N/A'];
const NEURO_GROUPS = ['Reflexes','Myotomes','Dermatomes','Neurodynamic'];

export default function NeurologyCard({
  rows = [], neuroTests = [],
  updRow, addRow, delRow,
  Section, GridTable, AddBtn,
}) {
  return (
    <Section title="Neurology — Reflexes · Myotomes · Dermatomes · Neurodynamic"
             icon={Crosshair} testid="sec-neuro">
      <GridTable cols={['Test (group)','Side','Result','Notes','Ref.']}>
        {(rows || []).map((r, i) => {
          const meta = neuroTests.find((t) => t.label === r.test);
          return (
            <tr key={i} data-testid={`neuro-${i}`}>
              <td>
                <select className="input" value={r.test || ''}
                        onChange={(e) => updRow('neurology', i, { test: e.target.value })}>
                  <option value="">—</option>
                  {NEURO_GROUPS.map((group) => (
                    <optgroup key={group} label={group}>
                      {neuroTests.filter((t) => t.group === group).map((t) => (
                        <option key={t.label} value={t.label}>{t.label}</option>
                      ))}
                    </optgroup>
                  ))}
                </select>
              </td>
              <td>
                <select className="input" value={r.side || ''}
                        onChange={(e) => updRow('neurology', i, { side: e.target.value })}>
                  {['', ...SIDES].map((s) => <option key={s}>{s}</option>)}
                </select>
              </td>
              <td>
                <input className="input" value={r.result || ''}
                       onChange={(e) => updRow('neurology', i, { result: e.target.value })}
                       placeholder="2+, diminished, +ve…"/>
              </td>
              <td>
                <input className="input" value={r.notes || ''}
                       onChange={(e) => updRow('neurology', i, { notes: e.target.value })}/>
              </td>
              <td>
                {meta?.link ? (
                  <a href={meta.link} target="_blank" rel="noopener noreferrer"
                     className="text-brand inline-flex items-center gap-1 text-xs"
                     data-testid={`neuro-ref-${i}`}>
                    Open <ExternalLink className="w-3 h-3"/>
                  </a>
                ) : <span className="text-fg-muted text-xs">—</span>}
              </td>
              <td className="print:hidden">
                <button onClick={() => delRow('neurology', i)} className="text-[#B83A3A] p-1">
                  <Trash2 className="w-4 h-4"/>
                </button>
              </td>
            </tr>
          );
        })}
      </GridTable>
      <AddBtn onClick={() => addRow('neurology', {
        test: '', side: '', result: '', notes: '',
      })} testid="add-neuro"/>
    </Section>
  );
}
